import { EPropertySettingTypes } from 'api/meta/enums/nodes/properties/EPropertySettingTypes';
import toString from 'lodash/toString';
import type { PropertyValue } from 'state/data/dataState';
import type { Node_ } from 'state/selectedTemplate/selectedTemplateStore';
import { filterMap } from 'utils/array';
import { getDisplayName } from 'utils/names';

export function createGetNodePropertyValueFallbackToNodeId(templateNode: Node_, targetPropertyName: string) {
  const textPropertiesSortedByName = getTextPropertiesSortedByName(templateNode);

  return (nodeProperties: Record<string, PropertyValue>) => {
    const targetValue = nodeProperties[targetPropertyName];

    if (targetValue !== undefined && targetValue !== null && toString(targetValue).length > 0) {
      return `${toString(targetValue)}`;
    }

    for (const { technicalName, displayName } of textPropertiesSortedByName) {
      const value = nodeProperties[technicalName];
      if (value !== undefined && value !== null && toString(value).length > 0) {
        return `${toString(value)} (${displayName})`;
      }
    }

    const idValue = toString(nodeProperties['Id']);

    return `${toString(idValue)}`;
  };
}

function getTextPropertiesSortedByName(templateNode: Node_) {
  return filterMap(templateNode.properties, (property) => {
    if (property.settings.$type === EPropertySettingTypes.Text) {
      return {
        ...property,
        displayName: getDisplayName(property.displayNames)
      };
    }
  }).sort((a, b) => a.technicalName.localeCompare(b.technicalName));
}
